import React, { useEffect, useState } from "react";
import { getBlogs } from "../api/client";
import { Link } from "react-router-dom";
import { getImageUrl } from "../utils/imageUtils";


const Blogs = ({ settings, lang }) => {
    const [blogs, setBlogs] = useState([]);
    const [loading, setLoading] = useState(true);

    useEffect(() => {
        const fetchData = async () => {
            try {
                const response = await getBlogs();
                setBlogs(response.data || []);
            } catch (error) {
                console.error("Failed to fetch blogs:", error);
            } finally {
                setLoading(false);
            }
        };
        fetchData();
    }, []);

    const getText = (en, ar) => (lang === "en" ? en : ar);

    const t = (key) => {
        if (!settings) return "";
        const globalData = lang === "en" ? settings.en : settings.ar;
        return (globalData && globalData[key]) ? globalData[key] : "";
    };

    // Helper to truncate text
    const truncate = (str, n) => {
        return (str && str.length > n) ? str.substr(0, n - 1) + '...' : str;
    };

    const getStatic = (key, fallback) => {
        const staticData = lang === "en" ? settings.en : settings.ar;
        return (staticData && staticData[key]) ? staticData[key] : fallback;
    };

    useEffect(() => {
        document.title = getStatic("page_title_blog", "إينوبريدج - عنا");

        // Update meta description
        const metaDesc = document.querySelector("meta[name='description']");
        if (metaDesc) {
            metaDesc.setAttribute("content", getStatic("meta_description_blog", "إينوبريدج - عنا"));
        }

        // Update meta keywords
        const metaKeywords = document.querySelector("meta[name='keywords']");
        if (metaKeywords) {
            metaKeywords.setAttribute("content", getStatic("meta_keyword_blog", "إينوبريدج - عنا"));
        }
    }, [lang, settings]);

    // if (loading) return <div className="text-center py-5">Loading...</div>; // Removed blocking loader

    return (
        <>
            <header className="py-5 bg-body header header1">
                <div className="container py-5 text-center">
                    <div className="layout-h"></div>
                    <h1 className="display-4 fw-bold mb-3" data-aos="fade-up">
                        {getStatic("blog_title", "مدونتنا")}
                    </h1>
                    <p className="lead text-muted mx-auto" style={{ maxWidth: '700px' }} data-aos="zoom-in" data-aos-delay="100">
                        {getStatic("blog_desc", "أحدث الرؤى والاتجاهات والأخبار...")}
                    </p>
                </div>
            </header>

            <section className="py-5 bg-card">
                <div className="container">
                    <div className="row gy-4 justify-content-center" id="blog-grid">
                        {loading ? (
                            <div className="col-12 py-5 text-center">
                                <div className="spinner-border text-primary" role="status">
                                    <span className="visually-hidden">Loading...</span>
                                </div>
                            </div>
                        ) : (
                            blogs.length > 0 ? (
                                blogs.map((b, i) => (
                                    <div className="col-lg-4 col-md-6" data-aos="fade-up" data-aos-delay="100" key={i}>
                                        <div className="card-custom h-100 p-0 overflow-hidden group d-flex flex-wrap">
                                            <div className="position-relative overflow-hidden w-100">
                                                <img src={getImageUrl(b.image, 'imgPro')} className="w-100 object-fit-cover" style={{ height: '200px' }} alt="Blog Post" />
                                            </div>
                                            <div className="p-4 d-flex flex-column">
                                                <small className="text-muted mb-2">{new Date(b.created_at).toLocaleDateString()}</small>
                                                <p className="text-muted mb-4 flex-grow-1">
                                                    {truncate(lang === 'en' ? b.content_en : b.content_ar, 100)}
                                                </p>
                                                <Link to={`/blog/${b.slug_en}`} className="fw-bold text-primary mt-auto">
                                                    {getText("Read Article", "اقرأ المقال")} <i className="ri-arrow-right-line"></i>
                                                </Link>
                                            </div>
                                        </div>
                                    </div>
                                ))
                            ) : (
                                <div className="col-12" data-aos="fade-up">
                                    <div className="card-custom h-100 py-5 overflow-hidden group text-center">
                                        <p className="m-0">{getText("There is no blog at the moment.", "لا توجد مدونات فى الوقت الحالى")}</p>
                                    </div>
                                </div>
                            )
                        )}
                    </div>
                </div>
            </section>
        </>
    );
};

export default Blogs;
